import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetProductPropertiesApiParameter extends ApiParameter {
    productIds: string[];
    type: string;
}

interface categoriesIds {
    categoryName: string;
    categoryId: string;
}

interface customProperties {
    [key: string]: string;
}

export interface ProductCategoriesModel extends BaseModel {
    productProperties: {
        id: string;
        categories: customProperties[];
        brandName: string;
        categoriesIds: categoriesIds[];
        customProperties: customProperties;
    }[];
}

const customProductsCategoriesURI = "api/v1/productproperties";

export async function getProductCategories(
    parameter: GetProductPropertiesApiParameter,
): Promise<ServiceResult<ProductCategoriesModel>> {
    try {
        const result = await post<GetProductPropertiesApiParameter, ProductCategoriesModel>(
            `${customProductsCategoriesURI}/`,
            parameter,
        );

        return {
            successful: true,
            result,
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching custom product categories:", error);
        throw error;
    }
}
